const config = {
  imagesBaseURL: 'https://manager.funky-office.gr/images/',
  //imagesBaseURL: 'http://localhost/iarts/eshop/admin/images/',
  eshop_title: 'Funky Office'
};

export default config;